<template>
    <div id="showcase">
        <section class="how-it-works-section my-5">
            <div class="container text-center">
                <div class="row justify-content-center">
                    <div class="col">
                        <h1 class="section-title mb-5">Revolutionary & Uncompromised Design</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="showcase-container col-12 col-md-6" data-aos="fade-right" data-aos-duration="800">
                        <img class="w-100 showcase-img" alt="SPIRITT showcase" src="img/saas/showcase/probeauty.png">
                    </div>
                    <div class="showcase-container col-12 col-md-6" data-aos="fade-left" data-aos-duration="800">
                        <img class="w-100 showcase-img" alt="SPIRITT showcase" src="img/saas/showcase/wroti.png">
                    </div>
                    <div class="showcase-container col-12 col-md-6" data-aos="fade-right" data-aos-duration="800">
                        <img class="w-100 showcase-img" alt="SPIRITT showcase" src="img/saas/showcase/matchpointer.png">
                    </div>
                    <div class="showcase-container col-12 col-md-6"  data-aos="fade-left" data-aos-duration="800">
                        <img class="w-100 showcase-img" alt="SPIRITT showcase" src="img/saas/showcase/perpage.png">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  export default {
    name: 'showcase',
  }
</script>

<style lang="css" scoped>
    #showcase {
        background-image: linear-gradient(180deg, #fff, #f1f1f1);
        overflow: hidden;
        content: "";
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        position: relative;
        color: #000000;
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .section-title {
        font-size: 45px;
        font-weight: 300;
        line-height: 1;

    }
    .showcase-container{
        padding: 15px !important;
    }
    .showcase-img{
        border-radius: 1rem;
    }
    .line {
        object-fit: contain;
        width: 95vw;
        margin: auto;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }
    @media (max-width: 767px) {
        .section-title {
            font-size: 30px;
        }
        .sub-title {
            font-size: 18px;
        }
    }
</style>
